import { Spinner } from "@hightouch/htui";

import { PreworkspacePage } from "src/components/layout/preworkspace-page";
import { AuthenticatedRoute } from "src/components/router/authenticated-route";
import { NoContextOutlet } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const McpConnectPage = lazyNamed(() => import("./mcp-connect"), "Page");

const McpConnectLayout = () => {
  return (
    <PreworkspacePage title="Connect to Claude">
      <NoContextOutlet />
    </PreworkspacePage>
  );
};

export const routes = {
  path: "mcp-connect",
  element: <McpConnectLayout />,
  children: [
    {
      index: true,
      element: (
        <AuthenticatedRoute loadingFallback={<Spinner size="lg" m="auto" />}>
          <McpConnectPage />
        </AuthenticatedRoute>
      ),
    },
  ],
};
